module.exports = __webpack_public_path__ + "assets/img/img-fv.d49e79fe.jpg";